import { Row, Col, Form, Button } from "antd";
import { useContext, useEffect, useState } from "react";
import useFetch from "../../hooks/useFetch";
import CustomFormItems from "../common/CustomFormItems";
import { IndexContext } from "../../context/IndexContext";

const layout = {
  labelCol: {
    span: 24,
    padding: 0,
  },
  wrapperCol: {
    span: 24,
  },
};

export default function ActivityDataRemark({
  currentlyEditEmissionID,
  getAllEmissionData,
  setIsModalOpen,
  existingActivityDataRemark,
}) {
  const [form] = Form.useForm();

  const [fetchWrapper] = useFetch();

  const { notificationApi } = useContext(IndexContext);

  const [buttonLoading, setButtonLoading] = useState(false);

  const form_properties = [
    {
      type: "textbox",
      name: "Remark",
      label: "Remark",
      required: true,
    },
  ];

  /** API to save activity data */
  function saveActivityDataRemark(form_data) {
    // set to button loading
    setButtonLoading(true);

    fetchWrapper({
      endpoint_url: "emission_data_entry/saveActivityDataRemark",
      method: "POST",
      body: {
        form_data: form_data,
        activity_data_ID: currentlyEditEmissionID,
      },
      onSuccess: (response) => {
        setButtonLoading(false);
        setIsModalOpen(false);
        getAllEmissionData();
        notificationApi.success({
          message: response.message,
        });
      },
      onResponseError: (response) => {
        notificationApi.error({
          message: response.message,
        });
      },
    });
  }

  useEffect(() => {
    if (existingActivityDataRemark) {
      form.setFieldValue("Remark", existingActivityDataRemark);
    }
  }, []);

  return (
    <Row>
      <Col span={12} offset={6}>
        <Form {...layout} form={form} onFinish={saveActivityDataRemark}>
          <CustomFormItems form_properties={form_properties} />
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              loading={buttonLoading}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Col>
    </Row>
  );
}
